import * as React from "react";

import { appendToClassName } from "lib/helpers";

interface Props {
  title: string;
  rows: [string, string | React.ReactNode, boolean?][];
  className?: string;
}

export function KeyValueTable(props: Props) {
  const { title, rows, className } = props;

  return (
    <>
      <div className={appendToClassName("key-value-table", className)}>
        <p>{title}</p>
        <table>
          <tbody>
            {rows.map((r, i) => (
              <tr
                className={"key-value-row" + (r[2] ? " key-value-line" : "")}
                key={`r${i}`}
              >
                <td>{r[0]}</td>
                <td>{r[1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
